import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

import { EntityType, Size } from '../../types';
import { colors, sizes } from '../../styles';
import { Icon, IconName } from '../icons';

export type MarginPosition = 'left' | 'right' | 'top' | 'bottom';

export interface PropTypes {
  src?: string;
  size?: Size;
  margin?: MarginPosition;
  fallbackStyle?: 'light' | 'dark';
  className?: string;
  entityType?: EntityType;
}
interface State {
  broken: boolean;
}

const fallbackMap = {
  light: {
    background: colors.grey50,
    foreground: colors.grey900,
  },
  dark: {
    background: colors.grey900,
    foreground: colors.grey50o,
  },
  driver: 'user' as IconName,
  vehicle: 'vehicle' as IconName,
};

class PhotoCoin extends React.Component<PropTypes, State> {
  public static defaultProps: PropTypes = {
    entityType: 'driver',
    fallbackStyle: 'light',
    size: 'md',
    src: '',
  };

  public state: State = {
    broken: false,
  };

  public componentWillReceiveProps(nextProps) {
    if (this.props.src !== nextProps.src) {
      this.setState({ broken: false });
    }
  }

  public render() {
    const {
      className,
      entityType,
      fallbackStyle,
      margin,
      size,
      src,
    } = this.props;
    const { broken } = this.state;

    return (
      <svg
        className={c(className, size, margin)}
        version="1.1"
        viewBox="0 0 20 20"
      >
        <defs>
          <clipPath id="clip">
            <circle cx="10" cy="10" r="10" />
          </clipPath>
        </defs>
        <g clipPath="url(#clip)">
          <rect
            fill={fallbackMap[fallbackStyle].background}
            height="20"
            width="20"
            x="0"
            y="0"
          />
          <svg height="12" width="12" x="4" y="4">
            <Icon
              baseColor={fallbackMap[fallbackStyle].foreground}
              icon={fallbackMap[entityType]}
            />
          </svg>
          {!broken && (
            <image
              height="20"
              onError={this.handleBrokenImage}
              width="20"
              x="0"
              xlinkHref={src}
              y="0"
            />
          )}
        </g>
      </svg>
    );
  }

  private handleBrokenImage = e => {
    this.setState({ broken: true });
  };
}

const margins = ['top', 'right', 'bottom', 'left'].reduce(
  (rule, margin) =>
    rule +
    `
      &.${margin} {
        margin-${margin}: 0.75rem;
      }
    `,
  '',
);

const StyledPhotoCoin = styled(PhotoCoin)`
  ${sizes.createRules(sizes.coin)};
  ${margins};
`;

export default StyledPhotoCoin;
